/** @format */

import { useContext, useMemo } from "react";
import { PostMethod } from "../api/Api";
import { getSession } from "../sessionStorage/sessionStorageMethod";
import { logoutAbnormalFunction } from "../function/logoutAbnormalFunction";
import { Context } from "../stores/Provider";
import { setIsLoading } from "../function/setIsLoading";
import useNavigateByAgent from "./useNavigateByAgentHooks";
import { initApiModelType, pdfDownloadRequstType, pdfDownloadResponseType } from "../constance/typeModel";
import { initApiResponse } from "../constance/constance";

const usePdfDownloadHooks = () => {
  const { navigateByAgent } = useNavigateByAgent();
  const { state, dispatch } = useContext(Context);
  const userInfoData = getSession("user");
  const userStatus = useMemo(() => state.user_status.status, [state.user_status.status]);

  const pdfDownloadHandler = async () => {
    let response: initApiModelType<pdfDownloadResponseType> = initApiResponse;
    let data = { user_id: userInfoData.user_id, entry_id: userInfoData.entry_id };
    setIsLoading(true, dispatch);
    response = await PostMethod<pdfDownloadRequstType, pdfDownloadResponseType>(data, "/entry_info_download");
    if (response.code !== 200) {
      if (response.code === 401) {
        return logoutAbnormalFunction(response, dispatch, navigateByAgent, state.agentPath, state.zAccount);
      } else {
        return navigateByAgent("/system_error");
      }
    }
    if (response.response_data === undefined) return setIsLoading(false, dispatch);
    // 日付取得
    const date = new Date();
    const today =
      date.getFullYear().toString() +
      String(date.getMonth() + 1).padStart(2, "0") +
      String(date.getDate()).padStart(2, "0");

    // ファイル名
    const fileName = "ゼウスWeb申込システム_";
    //a要素を生成
    let element = document.createElement("a");
    //a要素のhref属性を設定
    element.href = "data:image/pdf;base64," + encodeURI(response.response_data.data);
    //a要素のdownload属性を設定
    element.download = fileName.concat(today, ".pdf");
    //a要素のtarget属性を設定
    element.target = "_blank";
    //a要素のクリック実行
    element.click();

    setIsLoading(false, dispatch);
  };
  return { pdfDownloadHandler, userStatus };
};

export default usePdfDownloadHooks;
